/** 会话上下文的展示状态；压缩完成并不代表已获得压缩后的真实 token 数。 */
export type CoworkContextState = 'current' | 'compacting' | 'pending' | 'unknown';

/** 绑定真实根请求模型的窗口状态，可随 usage_json 持久保存。 */
export interface CoworkContextSnapshot {
  state: CoworkContextState;
  /** SDK 根请求返回的模型身份；缺失时不能借用全局所选模型。 */
  modelId?: string;
}

/** 读取数据库/API 中的可选状态；损坏字段降为未知，旧记录未携带时保留兼容。 */
export function readCoworkContextSnapshot(value: unknown): CoworkContextSnapshot | undefined {
  if (value === undefined) return undefined;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return { state: 'unknown' };
  const { state, modelId } = value as Record<string, unknown>;
  if (!['current', 'compacting', 'pending', 'unknown'].includes(String(state))) return { state: 'unknown' };
  if (modelId !== undefined && (typeof modelId !== 'string' || !modelId.trim()
    || modelId.length > 256 || /[\x00-\x1f\x7f]/.test(modelId))) return { state: 'unknown' };
  return { state: state as CoworkContextState, ...(typeof modelId === 'string' ? { modelId } : {}) };
}
